<div class="container py-5 mt-4 mt-lg-5 mb-lg-4 my-xl-5">
  <div class="row pt-sm-2 pt-lg-0">
    <gs-sidebar #sidebar class="col-lg-3 pe-lg-4 pe-xl-5 mt-n3"></gs-sidebar>
    <!-- Page content-->
    <div class="col-lg-9 pt-4 pb-2 pb-sm-4" [@routeAnimations]="o.activatedRouteData">

      <router-outlet #o="outlet"></router-outlet>

    </div>
  </div>
</div>
<!-- Divider for dark mode only-->
<hr class="d-none d-dark-mode-block">
<!-- Sidebar toggle button-->
<button (click)="sidebar.openMenu()" class="d-lg-none btn btn-sm fs-sm btn-primary shadow w-100 rounded-0 fixed-bottom"><i class="ai-menu me-2"></i>Meniu cont</button>
